import { useEffect, useState } from "react";

export type RouteView = "briefing" | "story" | "audit" | "compare" | "sources" | "saved" | "debug";
export interface Route { view: RouteView; storyId?: string; articleId?: string }

function readRoute(): Route {
  const parts = window.location.hash.replace(/^#\/?/, "").split("/").filter(Boolean);
  if (parts[0] === "story" && parts[1]) return { view: "story", storyId: decodeURIComponent(parts[1]) };
  if (parts[0] === "audit" && parts[1] && parts[2]) return { view: "audit", storyId: decodeURIComponent(parts[1]), articleId: decodeURIComponent(parts[2]) };
  if (["compare", "sources", "saved", "debug"].includes(parts[0])) return { view: parts[0] as RouteView };
  return { view: "briefing" };
}

export function routePath(route: Route): string {
  if (route.view === "story") return `#/story/${encodeURIComponent(route.storyId ?? "")}`;
  if (route.view === "audit") return `#/audit/${encodeURIComponent(route.storyId ?? "")}/${encodeURIComponent(route.articleId ?? "")}`;
  return route.view === "briefing" ? "#/" : `#/${route.view}`;
}

export function useHashRoute() {
  const [route, setRoute] = useState<Route>(() => readRoute());
  useEffect(() => {
    const update = () => setRoute(readRoute());
    window.addEventListener("hashchange", update);
    return () => window.removeEventListener("hashchange", update);
  }, []);
  const navigate = (next: Route) => { window.location.hash = routePath(next).slice(1); };
  return { route, navigate };
}
